// src/utils/crypto-utils.js

/**
 * Criptografa um texto (senha) usando AES-GCM.
 * @param {string} plaintext - O texto a ser criptografado.
 * @returns {Promise<{ciphertext: string, iv: string}>} - Um objeto com o texto cifrado e o IV, ambos em Base64.
 */
export async function encryptData(plaintext) {
    // A CHAVE SECRETA - DEVE SER IDÊNTICA À DO ESP32
    // Usando 16 bytes (128 bits)
    const keyBytes = new Uint8Array([
        0x2b, 0x7e, 0x15, 0x16, 0x28, 0xae, 0xd2, 0xa6,
        0xab, 0xf7, 0x15, 0x88, 0x09, 0xcf, 0x4f, 0x3c
    ]);

    // 1. Gera um IV (Nonce) aleatório de 12 bytes para cada criptografia
    const iv = window.crypto.getRandomValues(new Uint8Array(12));

    // 2. Prepara os dados para a API
    const encoder = new TextEncoder();
    const data = encoder.encode(plaintext);
    const cryptoKey = await window.crypto.subtle.importKey(
        "raw",
        keyBytes,
        { name: "AES-GCM" },
        false,
        ["encrypt"]
    );

    // 3. Criptografa
    const encryptedBuffer = await window.crypto.subtle.encrypt(
        {
            name: "AES-GCM",
            iv: iv,
        },
        cryptoKey,
        data
    );

    // 4. Converte o resultado para Base64 para ser enviado via JSON
    const ciphertext = btoa(String.fromCharCode.apply(null, new Uint8Array(encryptedBuffer)));
    const ivBase64 = btoa(String.fromCharCode.apply(null, iv));

    return { ciphertext, iv: ivBase64 };
}